import { createRouter, createWebHistory } from "vue-router"
import LandingPage from "@/pages/LandingPage"
import RegistrationPage from "@/pages/RegistrationPage"
import TermsPage from "@/pages/TermsPage"
import ErrorPage404 from "@/pages/ErrorPage404"
import ErrorPage401 from "@/pages/ErrorPage401"
import ChargingPage from "@/pages/ChargingPage"
import CardRegistrationResultPage from "@/pages/CardRegistrationResultPage"
import MaintenancePage from "@/pages/MaintenancePage"
import { useDictionaryStore } from "@/store/dictionary"

const routerHistory = createWebHistory(
  process.env.NODE_ENV === "production" ? "/gc" : "/"
)

const router = createRouter({
  history: routerHistory,
  routes: [
    {
      path: "/",
      name: "LandingPage",
      component: LandingPage
    },
    {
      path: "/registration",
      name: "RegistrationPage",
      component: RegistrationPage
    },
    {
      path: "/card-registration-success",
      name: "CardRegistrationResultPage",
      component: CardRegistrationResultPage
    },
    {
      path: "/terms",
      name: "TermsPage",
      component: TermsPage
    },
    {
      path: "/charging/:temporaryCode",
      name: "ChargingPage",
      component: ChargingPage,
      props: true
    },
    {
      path: "/401",
      name: "ErrorPage401",
      component: ErrorPage401
    },
    {
      path: "/maintenance",
      name: "Maintenance",
      component: MaintenancePage
    },
    {
      path: "/:notFound(.*)",
      name: "ErrorPage404",
      component: ErrorPage404
    }
  ]
})

router.beforeEach(async (to) => {
  const dictionaryStore = useDictionaryStore()

  await dictionaryStore.fetchDynamicConfig()

  const maintenanceMode = dictionaryStore.dynamicConfig?.maintenanceMode

  if (maintenanceMode?.enabled && to.name !== "Maintenance") {
    return { name: "Maintenance" }
  }

  if (!maintenanceMode?.enabled && to.name === "Maintenance") {
    return { name: "LandingPage" }
  }
})

export default router
